import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/PageTitle/PageTitle";
import Button from "../../components/Button/Button";
import { Grid, Typography } from "@mui/material";
import CardCount from "../../components/CardCount/CardCount";
import InputGroup from "../../components/FormComponent/InputGroup";
// import SelectGroup from "../../components/FormComponent/SelectGroup.js";
import {
  Group as StudentIcon,
  School as GraduateIcon,
  Class as ClassIcon,
  EmojiPeople as TeacherIcon
} from "@mui/icons-material";
import Modal from "../../components/Modal/index";
import { useState } from "react";
import useStyles from "../dashboard/styles";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

// import {
//   Group as StudentIcon,
//   School as GraduateIcon,
//   Class as ClassIcon,
//   EmojiPeople as TeacherIcon
// } from "@mui/icons-material";
// import useStyles from "../dashboard/styles";
import Table from "../../components/Table/Table";

const Welfare = () => {
  const [leave, setLeave] = useState("");
  const handleChange = (e) => {
    setLeave(e.target.value);
  };
  const classes = useStyles();
  // const [leaverequestdata, setLeaveRequestData] = useState({
  //   Leavetype: "",
  //   numberOfdays: ""
  // });
  const [modalisopen, setModalIsOpen] = useState(false);
  // const handleInputChange = (e) => {
  //   // const { name, value } = e.target;
  //   // setLeaveRequestData((prevleaverequestdata) => ({ ...prevleaverequestdata, [name]: value }));
  //   setLeaveRequestData(e.target.value);
  // };
  const handleSubmit = (e) => {
    e.preventDefault();
    // const leavedata = {
    //   id: Math.floor(Math.random() * 10000),
    //   name: leaverequestdata
    // };
    // console.log(leavedata);
  };
  const columns = [
    {
      name: "Leave Type",
      selector: (row) => row?.Leavetype
    },
    {
      name: "Number of Days",
      selector: (row) => row?.numberOfdays
    },
    {
      name: "Days Left",
      selector: (row) => row?.daysleft
    },
    {
      name: "Status",
      selector: (row) => row?.status
    },
    {
      name: "Request Date",
      selector: (row) => row?.requestdate
    },
    {
      name: "Delete",
      selector: (row) => row?.delete
    }
  ];

  const data = [
    {
      id: "65f5871946cee24920a0e773",
      Leavetype: "Annual",
      requestdate: "02/20/2020",
      status: "pending",
      gender: "male",
      numberOfdays: "10 days",
      daysleft: "0 "
    },
    {
      id: "65f58719cb9ad1605322f36b",
      Leavetype: "Annual",
      requestdate: "05/30/2034",
      status: "pending",
      gender: "male",
      numberOfdays: "20 days",
      daysleft: "0 "
    },
    {
      id: "65f58719ec1878d350b95aec",
      Leavetype: "Annual",
      requestdate: "03/22/2024",
      status: "pending",
      gender: "male",
      numberOfdays: "100 days",
      daysleft: "0 "
    }
  ];

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Welfare"
            subtitle="Request for leave, days off and any other time off work from the organization."
            button={
              <div className="flex gap-10">
                <Button
                  variant="primaryoutline"
                  buttonSize="small"
                  color="btnfontprimary"
                  buttonName="Leave calender"
                />
                <Button
                  variant="primary"
                  buttonSize="small"
                  color="btndefault"
                  onClick={() => {
                    setModalIsOpen(true);
                  }}
                  buttonName="Request Timeoff"
                />
              </div>
            }
          />
          <Grid container spacing={4}>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <CardCount
                title="Total Days off"
                count={30}
                icon={<StudentIcon />}
              />
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <CardCount
                title="Total Days Taken"
                count={6}
                icon={<GraduateIcon />}
              />
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <CardCount
                title="Days Rolled Over"
                count={1}
                icon={<ClassIcon />}
              />
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <CardCount
                title="Mandatory Off Days"
                count={2}
                icon={<TeacherIcon />}
              />
            </Grid>
          </Grid>
          <Table data={data} columns={columns} subHeader={true} />
          <Modal
            title="Leave Request"
            subtitle="Fill in the details to request for the a leave from your organization."
            modalContent={
              <>
                <Typography gutterBottom>
                  <div>
                    <label htmlFor="" style={{ fontWeight: "500", fontSize: "16px", marginTop: "16px", marginBottom: "6px" }}>Leave Type</label>
                    <FormControl fullWidth>
                      <InputLabel>Leave Type</InputLabel>
                      <Select
                        value={leave}
                        label="Leave Type"
                        onChange={handleChange}
                      >
                        <MenuItem value={10}>Annual Leave</MenuItem>
                        <MenuItem value={20}>Emergency Leave</MenuItem>
                        <MenuItem value={30}>Food Leave</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div>
                    <label htmlFor="" style={{ fontWeight: "500", fontSize: "16px", marginTop: "16px", marginBottom: "6px" }}>Number of Days</label>
                    <FormControl fullWidth>
                      <InputLabel>Number Of Days</InputLabel>
                      <Select
                        value={leave}
                        label="Number Of Days"
                        onChange={handleChange}
                      >
                        <MenuItem value={10}>Ten</MenuItem>
                        <MenuItem value={20}>Twenty</MenuItem>
                        <MenuItem value={30}>Thirty</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  {/* <div>
                    <InputGroup
                      onChange={handleInputChange}
                      name="Leavetype"
                      label="Leave Type"
                      margin="normal"
                      placeHolder="Annual Leave"
                      inputType="text"
                    />
                  </div> */}
                </Typography>
                {/* <Typography gutterBottom>
                  <div>
                    <InputGroup
                      onChange={handleInputChange}
                      value={leaverequestdata.numberOfdays}
                      name="numberOfdays"
                      label="Number Of Days"
                      margin="normal"
                      placeHolder="10 days"
                      inputType="text"
                    />
                  </div>
                </Typography> */}
                <Typography className={`${classes.subjectdivide}`} gutterBottom>
                  <div className={`${classes.subject_divide_items}`}>
                    <InputGroup
                      label="Start Date"
                      margin="normal"
                      placeHolder="10 Jan, 2024"
                      inputType="date"
                    />
                  </div>
                  <div className={`${classes.subject_divide_items}`}>
                    <InputGroup
                      label="End Date"
                      margin="normal"
                      placeHolder="31 Jan, 2024"
                      inputType="date"
                    />
                  </div>
                </Typography>
                <Typography gutterBottom style={{ marginBottom: "16px" }}>
                  <div>
                    <InputGroup
                      // onChange={handleChange}
                      label="Note"
                      margin="normal"
                      placeHolder="Add a note to your leave request"
                      inputType="text"
                    />
                  </div>
                </Typography>
              </>
            }
            modalFooter={
              <>
                <Button
                  type="submit"
                  onClick={handleSubmit}
                  variant="primary"
                  buttonName="Send Leave Request"
                  buttonSize="full"
                  color="btndefault"
                />
              </>
            }
            isopen={modalisopen}
            closeModal={() => {
              setModalIsOpen(false);
            }}
          />
        </>
      }
    />
  );
};

export default Welfare;
